import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateCustomer } from '../redux/slices/customerReportSlice';
import '../modalstyles/CustomerEditModal.css';

const CustomerEditModal = ({ isOpen, onClose, customer }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (customer) {
      setFormData({
        fullName: customer.fullName || '',
        email: customer.email || '',
        mobileNumber: customer.mobileNumber || '',
        address: customer.address || '',
        pincode: customer.pincode || '',
        bankAccount: customer.bankAccount || '',
        bankIFSC: customer.bankIFSC || '',
        bankBranch: customer.bankBranch || '',
        branchId: customer.branchId || '',
        bankName: customer.bankName || '',
      });
    }
  }, [customer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      fullName: formData.fullName,
      email: formData.email,
      mobileNumber: formData.mobileNumber,
      address: formData.address,
      pincode: formData.pincode,
      bankAccount: formData.bankAccount,
      bankIFSC: formData.bankIFSC,
      bankBranch: formData.bankBranch,
      branchId: Number(formData.branchId),
      bankName: formData.bankName,
    };

    try {
      console.log('[UPDATE PAYLOAD]', payload);
      await dispatch(updateCustomer({ id: customer.id, payload })).unwrap();
      alert('Customer updated successfully');
      onClose();
    } catch (error) {
      console.error('[UPDATE ERROR]', error);
      alert('Failed to update customer: ' + (error.message || 'Unknown error'));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="CustomerEditModal-overlay">
      <div className="CustomerEditModal-container">
        <h3 className="CustomerEditModal-title">Edit Customer</h3>

        <div className="CustomerEditModal-form">
          <div className="CustomerEditModal-group">
            <label>Full Name</label>
            <input name="fullName" value={formData.fullName} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Email</label>
            <input name="email" value={formData.email} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Mobile Number</label>
            <input name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Pincode</label>
            <input name="pincode" value={formData.pincode} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group CustomerEditModal-full">
            <label>Address</label>
            <textarea name="address" rows="2" value={formData.address} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Bank Account</label>
            <input name="bankAccount" value={formData.bankAccount} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Bank IFSC</label>
            <input name="bankIFSC" value={formData.bankIFSC} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Bank Branch</label>
            <input name="bankBranch" value={formData.bankBranch} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Branch ID</label>
            <input name="branchId" value={formData.branchId} onChange={handleChange} />
          </div>

          <div className="CustomerEditModal-group">
            <label>Bank Name</label>
            <input name="bankName" value={formData.bankName} onChange={handleChange} />
          </div>
        </div>

        <div className="CustomerEditModal-buttons">
          <button className="CustomerEditModal-update" onClick={handleSubmit}>Update</button>
          <button className="CustomerEditModal-cancel" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default CustomerEditModal;
